
const WhatsAppButton = () => {
  return (
    <>
      {/* Desktop WhatsApp Button */}
      <a
        href="https://web.whatsapp.com/send?phone=34622664174&text=Quisiera%20información%20sobre%20cursos%20de%20maquinaria%20de"
        target="_blank"
        rel="noopener noreferrer"
        className="hidden md:flex fixed bottom-28 right-2 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full items-center justify-center shadow-lg transition-all duration-300 hover:scale-110 z-40 cursor-pointer"
      >
        <i className="fab fa-whatsapp text-white text-2xl"></i>
      </a>

      {/* Mobile WhatsApp Button */}
      <a
        href="https://wa.me/34622664174/?text=Quisiera%20información%20sobre%20cursos%20de%20maquinaria%20de"
        target="_blank"
        rel="noopener noreferrer"
        className="flex md:hidden fixed bottom-20 right-2 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full items-center justify-center shadow-lg transition-all duration-300 hover:scale-110 z-40 cursor-pointer"
      >
        <i className="fab fa-whatsapp text-white text-2xl"></i>
      </a>
    </>
  );
};

export default WhatsAppButton;
